import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';

export async function requestPasswordReset(email) {
  return resetPassword({ username: email });
}

export async function confirmPasswordReset({ email, code, newPassword }) {
  return confirmResetPassword({
    username: email,
    confirmationCode: code,
    newPassword: newPassword,
  });
}
